import React, { useEffect, useState } from "react";
import { useEducation } from "../../../hooks/useEducation";
import CourseClassList from "./CourseClassList";
import "./MyCourses.css";
import CourseCard from "../CourseCard";
import MyFavorites from "./MyFavorites";

const MyCourses = () => {
  const {
    myCourses,
    myCoursesLoading,
    myCoursesError,
    fetchMyCourses,
    toggleFavoriteCourse,
  } = useEducation();

  const [selectedCourse, setSelectedCourse] = useState(null);

  useEffect(() => {
    fetchMyCourses();
  }, [fetchMyCourses]);

  const handleFavoriteToggle = async (e, courseId) => {
    e.stopPropagation();
    try {
      await toggleFavoriteCourse(courseId);
      fetchMyCourses();
    } catch (error) {
      console.error("Error toggling favorite:", error);
    }
  };

  if (myCoursesLoading) {
    return <div className="loading-container">Loading your courses...</div>;
  }

  if (myCoursesError) {
    return (
      <div className="error-container">
        Error loading courses: {myCoursesError}
      </div>
    );
  }

  if (myCourses.length === 0) {
    return (
      <div className="empty-courses-container">
        <h2>You haven't enrolled in any courses yet</h2>
        <p>
          Explore our course catalog to find something you're interested in!
        </p>
      </div>
    );
  }

  const handleCourseSelect = (course) => {
    setSelectedCourse(course);
  };

  return (
    <div className="my-courses-container course__bubble">
      <div
        className="education_course_title_info"
        style={{ position: "absolute", top: "-20px" }}
      >
        Dine temaer
      </div>

      <div className="courses-layout">
        <MyFavorites />
      </div>
      <div className="courses-rows">
        {myCourses.map((course) => (
          <div key={course.id} className="course-row">
            <div className="course-item-container">
              <CourseCard
                myCourses={myCourses}
                course={course}
                onCourseClick={() => handleCourseSelect(course)}
                onFavoriteToggle={handleFavoriteToggle}
              />
            </div>
            <div className="course-classes-container">
              <CourseClassList
                courseId={course.course}
                courseName={course.course_name}
                enrollmentId={course.id}
                progressPercentage={course.progress_percentage}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyCourses;
